<template>
  <div
    v-if="scene"
    :style="'flex: 1 1 1px; opacity: ' + (isSceneEnabled ? '1' : '0.4') + ';'"
    style="display: relative; height: 92px; border-radius: 4px">
    <v-dialog
      v-model="preview_dialog"
      max-width="600px"
      class="template-pop-up template-pop-up-fix">
      <SceneAssetPreview
        v-on:close="preview_dialog = false"
        :scene="scene" />
    </v-dialog>
    <v-img
      height="92"
      width="220"
      dark
      cover
      :gradient="
        $vuetify.theme.dark
          ? `to top right, ${shadeColor(avg_color, 0, 0.3)}, ${shadeColor(
              avg_color,
              50,
              0.65
            )}`
          : `to top right, ${shadeColor(avg_color, -25, 0.01)}, ${shadeColor(
              avg_color,
              60,
              0.8
            )}`
      "
      :style="
        $vuetify.theme.dark
          ? `
        border-radius: 4px;
        overflow: hidden;
        backgroung-clip: context-box;
        background: ${shadeColor(avg_color, -100)};`
          : `
        border-radius: 4px;
        overflow: hidden;
        backgroung-clip: context-box;
        background: ${shadeColor(avg_color, 50)};`
      "
      :src="asset_img">
      <div style="opacity: 0.97; display: flex">
        <div
          v-if="state.channelOnAirEditMode || editMode"
          title="Drag to move Scene"
          class="darken text-center grabber"
          style="
            cursor: grab;
            z-index: 1;
            background-clip: context-box;
            flex-shrink: 0;
            display: flex;
          "
          :style="btnBg">
          <v-spacer />
          <v-divider
            style="color: white"
            class="mx-1"
            inset
            vertical />
          <v-divider
            style="color: white; margin-right: 1px; margin-left: 1px"
            inset
            vertical />
          <v-divider
            style="color: white"
            class="mx-1"
            inset
            vertical />
          <v-spacer />
        </div>

        <div
          @mouseenter="state.sceneConditionSummary = deluge.items[scene.did]"
          @mouseleave="state.sceneConditionSummary = false"
          :class="
            !state.channelOnAirEditMode && !editMode ? 'py-2 px-4' : 'pa-2'
          "
          style="
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            border-radius: 0px 4px 4px 0px;
            flex-grow: 1;
            height: 100%;
            gap: 6px;
            box-shadow: inset 0 0 15px #0000004d;
            min-height: 92px;
          ">
          <div
            title="Open Scene settings"
            class="pa-2 transbackground nice"
            @click="emit('OpenSettings')"
            :style="`border-radius: 4px;
              flex-grow: 1;
              flex-shrink: 2 !important;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: space-between;
              border-radius: 4px;
              max-width: ${
                state.channelOnAirEditMode || editMode ? '170px' : '194px'
              };
               background: ${asset_img ? color() : shadeColor(avg_color, -80, 0.85)};
               max-height: 40px;
              `">
            <div
              :style="` font-size: 14px;
                display: inline-block;
                white-space: nowrap !important;
                overflow: hidden !important;
                text-overflow: ellipsis !important;
                `">
              <v-icon class="mr-2 template-icon">
                {{ GetLogo(deluge.items[scene.did].scene_name.toLowerCase()) }}
              </v-icon>
              {{ deluge.items[scene.did].name }}
            </div>
          </div>
          <!-- Button Container -->
          <div class="button-container text-subtitle-2">
            <!-- Go live Button -->
            <div
              title="Switch to this Scene"
              @click="force_scene()"
              v-if="!scene.live && !state.channelOnAirEditMode && !editMode"
              class="actionbtn nice py-1"
              :style="
                btnBg
              ">
              <v-icon
                :color="current && !scene.live ? 'primary' : '#ffffff47'"
                v-if="!loading_live">
                mdi-chevron-double-right
              </v-icon>
              <v-progress-circular
                v-if="loading_live"
                indeterminate
                color="white"
                :size="18"
                :width="2"></v-progress-circular>
            </div>
            <!-- Go Live Button - Live Mode -->

            <div
              title="This Scene is currently playing"
              v-else-if="!state.channelOnAirEditMode && !editMode"
              :style="`cursor:pointer;border-radius:4px; ;border-radius: 4px;box-shadow: 0px 0px 8px 8px ${$vuetify.theme.themes.dark.primary}40 ;`"
              class="actionbtn nice py-1 transbackground_active">
              <v-icon color="white">mdi-chevron-double-right</v-icon>
            </div>
            <!-- End Go Live Button -->
            <div
              title="Open Scene Play Conditions"
              v-if="
                scene.valid &&
                scene.live &&
                Object.keys(deluge.items[scene.did].conditions.play_conditions)
                  .length > 0
              "
              @click="emit('OpenPlayConditions')"
              :style="`float: left;cursor:pointer;box-shadow: 0px 0px 8px 8px ${$vuetify.theme.themes.dark.primary}40 ;`"
              class="actionbtn transbackground_active nice">
              <v-icon color="white">mdi-motion-play-outline</v-icon>
            </div>
            <div
              title="Open Scene Play Conditions"
              v-else-if="
                Object.keys(deluge.items[scene.did].conditions.play_conditions)
                  .length > 0
              "
              @click="emit('OpenPlayConditions')"
              style="float: left; cursor: pointer"
              class="actionbtn nice"
              :class="scene?.live ? 'actionbtn-live' : 'actionbtn'"
              :style="
                btnBg
              ">
              <v-icon :color="scene.live ? 'white' : '#ffffff47'">
                mdi-motion-play-outline
              </v-icon>
            </div>
            <div
              v-if="deluge.items[scene.did].domination_mode > 0 && scene.live"
              @click="emit('OpenPlayConditions')"
              :style="`float: left;cursor:pointer;box-shadow: 0px 0px 8px 8px ${$vuetify.theme.themes.dark.primary}40 ;`"
              class="actionbtn transbackground_active nice">
              <v-icon color="white">mdi-star-shooting</v-icon>
            </div>
            <div
              v-else-if="deluge.items[scene.did].domination_mode > 0"
              @click="emit('OpenPlayConditions')"
              style="float: left; cursor: pointer"
              class="actionbtn nice"
              :style="
                btnBg
              ">
              <v-icon
                :color="
                  deluge.items[scene.did].domination_mode > 0
                    ? 'white'
                    : '#ffffff47'
                ">
                mdi-star-shooting
              </v-icon>
            </div>
            <!-- Trigger Start -->
            <!-- Trigger Not Live -->
            <div
              v-if="
                (!scene.live && deluge.items[scene.did].triggers.length > 0) ||
                deluge.templates[deluge.items[scene.did].scene_name]
                  ?.default_triggers.length > 0
              "
              @click="emit('OpenTriggers')"
              style="float: left; cursor: pointer"
              class="actionbtn nice"
              :style="
                btnBg
              ">
              <v-icon
                :color="
                  deluge.items[scene.did].triggers.length > 0 ||
                  deluge.templates[deluge.items[scene.did].scene_name]
                    ?.default_triggers.length > 0
                    ? 'white'
                    : '#ffffff47'
                ">
                mdi-share-all
              </v-icon>
            </div>
            <!-- Trigger Live -->
            <div
              v-else-if="
                (deluge.items[scene.did].triggers.length > 0 ||
                  deluge.templates[deluge.items[scene.did].scene_name]
                    ?.default_triggers.length > 0) &&
                scene.live
              "
              class="trigger-container">
              <div
                class="triggers trigger-top-btn transbackground_active nice"
                @click="emit('OpenTriggers')">
                <v-icon color="white">mdi-share-all</v-icon>
              </div>
            </div>
            <!-- END Triggers -->
          </div>
        </div>
      </div>
    </v-img>
  </div>
</template>
<script setup>
import SceneAssetPreview from './SceneAssetPreview.vue';
import { onMounted, ref, computed } from 'vue';
import { state } from '../../stores/deluge.js';
import { $http } from '../../stores/http.js';
import { deluge } from '@/stores/deluge.js';
import { getThumbnailForScene } from '@/utils/thumbnails.js';
const props = defineProps([
  'scene',
  'channel_id',
  'channel_did',
  'queue',
  'disabled',
  'current',
  'editMode',
]);
const loading_live = ref(false);
const asset_img = ref(undefined);
const avg_color = ref(undefined);
const preview_dialog = ref(false);

const isSceneEnabled = computed(() => {
  try {
    if (props.scene && props.scene.did && deluge.items?.[props.scene.did]) {
      return deluge.items?.[props.scene.did].enabled !== false;
    }
  } catch (e) {
    console.error('Error in isSceneEnabled:', e);
  }

  return true;
});

const emit = defineEmits([
  'OpenSceneModal',
  'OpenPlayConditions',
  'OpenTriggers',
  'OpenPlayConditions',
  'OpenSettings',
]);
onMounted(() => {
  const result = getThumbnailForScene(deluge.items[props.scene.did], deluge);
  asset_img.value = result.src;
  avg_color.value = result.color || 'rgb(50,50,50)';
});
function color() {
  if (avg_color.value) {
    return avg_color.value;
  } else {
    return 'rgb(50,50,50)';
  }
}
const btnBg = computed(() => {
  if (!avg_color.value) return 'background:var(--v-cardColor-base)';
  if (asset_img.value) return 'background:' + avg_color.value;
  return 'background:' + shadeColor(avg_color.value, -80, 0.85);
});
function force_scene() {
  if (!props.disabled) {
    loading_live.value = true;
    $http('GET', '/dynamic_engine/go_live?did=' + props.scene.did).then(() => {
      loading_live.value = false;
    });
  }
}
function shadeColor(color, percent, a) {
  if (!a) {
    a = 1;
  }
  if (color) {
    var st = color.split(',');
    var r = parseFloat(st[0].slice(4)) + percent;
    var g = parseFloat(st[1]) + percent;
    var b = parseFloat(st[2].substring(0, st[2].length - 1)) + percent;
    const result = `rgba(${r},${g},${b}, ${a})`;
    return result;
  }
}
function GetLogo(scene_name) {
  for (const template in deluge.templates) {
    if (template == scene_name) {
      return deluge.templates[template].icon;
    }
  }
  return 'mdi-cube';
}
// Note: thumbnail lookup is handled on mount and via getThumbnailForScene directly.
</script>

<style scoped lang="scss">
.actionbtn {
  width: 100%;
  height: 32px;
  cursor: pointer;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-container {
  bottom: 0;
  display: inline-block;
  width: 100%;
  display: flex;
  justify-content: stretch;
  gap: 4px;
}

// Triggers

.trigger-container {
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  width: 100%;
  height: 32px;
}

.triggers {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;
}

.grabber {
  display: inline-block;
  border-radius: 3px 0px 0px 3px;

  height: 92px;
  width: 32px;
  cursor: grab;
}
@keyframes fade-out {
  from {
    background: var(--v-primary-base);
    opacity: 1;
    z-index: 10;
  }
  to {
    background-color: rgba(0, 0, 0, 0);
    opacity: 0;
    z-index: -1;
  }
}
.transbackground_trigger {
  animation-name: fade-out;
  animation-duration: 2.5s;
  animation-timing-function: ease-in;
}
.template-icon {
  transition:
    opacity 0.15s ease-in-out,
    margin 0.25s ease-in-out;
}
</style>
